import firebase from 'firebase/app';

export default {
  signInFlow: 'redirect',
  signInSuccessUrl: '/new',
  signInOptions: [
    { provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      customParameters: { prompt: 'select_account' },
    },
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
  ]
}
